import { useTranslation } from 'react-i18next'

import { Button, Card, CardTitle, LineItemSelector } from '@reveni-io/reveni-ui'

import AdditionalReturnedProductsCardSkeleton from './AdditionalReturnedProductsCardSkeleton/AdditionalReturnedProductsCardSkeleton'
import * as Styles from './styles'

const AdditionalReturnedProductsCard = ({
  loading,
  unexpectedItems,
  onReviewAdditionalReturnedProducts,
  allowsEditReturnStatus,
}) => {
  const { t } = useTranslation()

  if (loading) return <AdditionalReturnedProductsCardSkeleton />
  if (!unexpectedItems?.length) return null

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={'0'}>{t('Productos devueltos adicionales')}</CardTitle>
      <Styles.ItemsContainer>
        {unexpectedItems.map(item => (
          <LineItemSelector key={item.id} lineItem={item} showToggle={false} showIndex={false} />
        ))}
      </Styles.ItemsContainer>
      {allowsEditReturnStatus && (
        <Button onClick={onReviewAdditionalReturnedProducts} fullWidth>
          {t('Revisar productos')}
        </Button>
      )}
    </Card>
  )
}

export default AdditionalReturnedProductsCard
